/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useState,
  useEffect,
} from 'react'

import { Helmet } from "react-helmet";
import { useIntl } from 'react-intl';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { getDay, parseISO, format } from 'date-fns';
import _ from "lodash";

import { useLocation, useNavigate } from 'react-router-dom';
import Lottie from "lottie-react";

import LoadingContent from 'app/modules/loading/LoadingContent';
import blink from '../../../_metronic/assets/animations/blink.json';
import blinkConfirmed from '../../../_metronic/assets/animations/blinkConfirmed.json';
import PurchaseMenu from 'app/utils/PurchaseMenu';

import {
  fetchCredits,
} from 'app/services/credits';

import {
  formatLongDateTime,
  formatLongDateToDate,
} from 'app/services/dates';

import {
formatMoney,
} from 'app/services/intFormat';

const CreditList = () => {
  const { credits, auth } = useSelector((state : any) => ({
    credits: state.credits,
    auth: state.auth,
  }), shallowEqual);

  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [list, setList] = useState<any>([]);

  const getBranchName = (value, first = true) => {
    if (value.relationships.origin.type === 'service') {
      return value.relationships.origin.relationships.fields[0].relationships.branch.attributes.name
    }

    if (value.relationships.origin.type === 'plan') {
      return first ?
        value.relationships.origin.relationships.branches[0].attributes.name :
        _.map(value.relationships.origin.relationships.branches, 'attributes.name')
    }
  }

  const getTypeLabel = (value) => {
    if (value.relationships.origin.type === 'plan') {
      if (value.relationships.origin.attributes.type === 'day_use') {
        return 'Day use';
      }
    }

    if (value.relationships.origin.type === 'service') {
      if (value.relationships.origin.attributes.modality === 'reservation') {
        return 'Locação';
      }
      if (value.relationships.origin.attributes.modality === 'class') {
        return 'Aula';
      }
    }

    return value.relationships.origin.attributes.type;
  }

  useEffect(() => {
    dispatch<any>(fetchCredits()).then((value) => {
      setList(value)
    });
  }, []);

  useEffect(() => {
    if(!auth.user) {
      navigate('/')
    }
  }, [auth]);

  const showItem = (item: any) => {
    return <div className="col-lg-6 mb-1 mb-lg-0">
      <div className="d-flex justify-content-center">
        <div
          className="card card-dashed flex-row flex-stack p-4 mb-6 w-100 cursor-pointer"
          onClick={() => navigate(`/compras/creditos/${item.id}`)}
        >
          <div className="d-flex align-items-center me-2">
            <div className="flex-grow-1">
              <div className="d-flex align-items-center fs-2 fw-bold flex-wrap pb-2">{item?.relationships?.origin?.attributes?.name}</div>
              <div className="fs-7 fw-semibold opacity-20 pb-1">{getBranchName(item)}</div>
              <div className="fs-7 fw-semibold opacity-20 pb-1">
                {item.attributes.paid_at && `Utilizado em ${formatLongDateToDate(item.attributes.paid_at, true)}`}
                {!item.attributes.paid_at && item.attributes.expired_at && `Válido até ${formatLongDateToDate(item.attributes.expired_at, true)}`}
                {!item.attributes.paid_at && !item.attributes.expired_at && `Sem data de válidade`}
              </div>
              <div className="fs-7 fw-semibold opacity-20 pb-1">Tipo {getTypeLabel(item)}</div>
              <div className="fs-7 fw-semibold opacity-20 pb-1">Adquirido {formatLongDateTime(item.attributes.created_at)}</div>
            </div>
          </div>
          <div className="d-flex ms-5">
            <div className="flex-grow-1 text-uppercase">
              {(item.relationships.status.attributes.name === 'active' && item.attributes.is_active) && <span className="flex d-flex text-primary fs-6 fw-bold">
                Disponível para uso
              </span>}

              {(item.relationships.status.attributes.name === 'paid') && <span className="flex d-flex text-gray-700 fs-6 fw-bold text-center">
                Crédito utilizado
              </span>}

              {(
                item.relationships.status.attributes.name === 'expired' ||
                (item.relationships.status.attributes.name !== 'paid' && item.attributes.is_expired)
              ) && <span className="flex d-flex text-danger fs-6 fw-bold text-center">
                Expirado
              </span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  return (<>

    <Helmet>
      <title>Minhas compras - Créditos - Atacante App</title>
    </Helmet>

    <PurchaseMenu />

    {<div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0 mb-13'>
        {list.length > 0 && <>
          <div className="mb-10">
            <h1 className="mb-3">
              Créditos adquiridos
            </h1>
          </div>
          <div className="row mt-10">
            {list.map(item => {
              return showItem(item)
            })}
          </div>
        </>}

        {credits.listLoading === false && list.length === 0 && <div className="my-10 text-center">
          <h2 className="mb-3">
            Você não efetuou nenhuma compra
          </h2>
          <div className="text-muted fw-semibold fs-5">
            Garanta descontos exclusivos para jogar com seus amigos!
          </div>
        </div>}

        {credits.listLoading === true && list.length === 0 && <LoadingContent />}
      </div>
    </div>}
  </>)
}

export {
  CreditList
}
